import $ from "jquery";

$(function () {
	function updateHeroHeight() {
		const $hero = $('.aka-block-hero-image');
		// const $heroImages = $('.hero-images');
		const headerHeight = $('.header').outerHeight() || 0;
		// const heroMessage = $('.hero-message').outerHeight() || 0;
		const windowHeight = $(window).height();
		const windowWidth = $(window).width();

		if (windowWidth < 1024) {
			$hero.css('height', 'auto');
		} else {
			const heroHeight = windowHeight - headerHeight;
			$hero.css('height', heroHeight + 'px');
			// const heroImagesHeight = (windowHeight - headerHeight) - heroMessage;
			// $heroImages.css('height', heroImagesHeight + 'px');
		}
	}

	// Run on load and resize
	$(window).on('load resize', updateHeroHeight);
});
